import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { GridRowModes, DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import AssignmentIcon from "@mui/icons-material/Assignment";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import * as services from "./../../services/services";
import AppBreadcrumbs from "./../../components/AppBreadcrumbs";
import SearchIcon from "@mui/icons-material/Search";
import { formatDate } from "../../utils/formatDate";
import { formatNumber } from "../../utils/formatNumber";

const History = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const filtered = rows.filter((p) =>
    p.petName.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { field: "no", headerName: "No", flex: 1 },
    { field: "petCode", headerName: "IDสัตว์เลี้ยง", flex: 1 },

    { field: "petName", headerName: "ชื่อสัตว์เลี้ยง", flex: 2 },
    { field: "service", headerName: "บริการ", flex: 1.5 },
    {
      field: "treatmentDate",
      headerName: "วันที่เข้ารับบริการ",
      flex: 1.5,
      valueGetter: (params) => {
        const date = new Date(params);
        return formatDate(date);
      },
    },
    { field: "doctor", headerName: "แพทย์ผู้รับผิดชอบ", flex: 2 },
    {
      field: "detail",
      headerName: "รายละเอียด",
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center", // กึ่งกลางแนวนอน
            alignItems: "center", // กึ่งกลางแนวตั้ง
            width: "100%",
            height: "100%",
          }}
        >
          <AssignmentIcon
            style={{ color: "#1976d2", cursor: "pointer" }}
            onClick={() => {
                if(params.row.service=='ฉีดวัคซีน'){
                  navigate(`/medical_history/${params.row.id}`, {
                    state: params.row, 
                  });
                }else{
                  navigate(`/medical_history/${params.row.id}`, {
                    state: params.row, 
                  });
                }
           
            }}
          />
        </div>
      ),
    },
  ];
  const fetchHistory = useCallback(async () => {
    const res = await services.getHistory();
    const rawData = res.data.data;

    const productsWithIndex = rawData.map((item, index) => ({
      ...item,
      no: index + 1,
      petId: item.pet.id,
      petCode: item.pet.petCode,
      petName: item.pet.name,
      service: item.serviceType =="vaccine"?"ฉีดวัคซีน":"ฝังไมโครชิป",
      treatmentDate: item.serviceDate,
      doctor: item.handledBy.title+" "+item.handledBy.name + "  " + item.handledBy.lastname,
      owner: item.pet.ownerName,
    }));

    setRows(productsWithIndex);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return (
    <>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" reverseOrder={false} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 2,
          my: 2,
        }}
      >
        {/* ส่วนซ้าย: หัวข้อ + Search */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography component="h2" variant="h5" sx={{ whiteSpace: "nowrap" }}>
            รายการการให้บริการ
          </Typography>
          <TextField
            fullWidth
            label="ค้นหา"
            placeholder="ชื่อสัตว์ / Pet ID"
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ maxWidth: { xs: "100%", sm: 420 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid
              rows={filtered}
              columns={columns}
              loading={loading}
            />
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default History;
